// extracted by mini-css-extract-plugin
export default {"title":"ESportLinks_title__owiUh","game_sgfi":"ESportLinks_game_sgfi__bcZN3","game_card":"ESportLinks_game_card__qcon0","text_tab":"ESportLinks_text_tab__ccCiC"};